module.exports = __webpack_public_path__ + "static/img/step02_pic.d5a9144.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/oem/reolink-cn/share/step02_pic.png
// module id = lYc7
// module chunks = 2